import React from 'react';

interface MondayIconProps {
  height?: number;
  className?: string;
}

export const MondayLogo: React.FC<MondayIconProps> = ({
  height = 26,
  className,
}) => {
  return (
    <svg
      height={height}
      viewBox="0 0 77.8 46.9"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g transform="matrix(3.6956523,0,0,3.6956523,-3.7266276e-4,-19.226192)">
        <g transform="translate(0,5.552)">
          <path
            fill="#F62B54"
            d="M2.6,12.3c-0.9,0-1.8-0.5-2.3-1.3c-0.5-0.8-0.4-1.8,0.1-2.6 l4.7-7.4c0.5-0.8,1.4-1.3,2.3-1.3c0.9,0,1.8,0.6,2.3,1.4c0.4,0.8,0.4,1.8-0.1,2.6l-4.7,7.4C4.4,11.8,3.5,12.3,2.6,12.3z"
          />
          <path
            fill="#FFCC00"
            d="M10.7,12.3c-1,0-1.8-0.5-2.3-1.3C8,10.1,8,9.1,8.5,8.3 l4.7-7.4c0.5-0.8,1.4-1.3,2.3-1.3c1,0,1.8,0.6,2.3,1.4c0.4,0.8,0.4,1.8-0.2,2.6l-4.7,7.4C12.4,11.8,11.6,12.3,10.7,12.3z"
          />
          <ellipse fill="#00CA72" cx="18.6" cy="10" rx="2.4" ry="2.4" />
        </g>
      </g>
    </svg>
  );
};
